import React from "react";
import { Link } from "react-router-dom";
import ctaImage from "../assets/images/solar/8.png";
import HtmlContent, { PhotoLink } from "./HtmlContent";
import { mediaUrl, sectionBlocks, useSiteData } from "../lib/siteApi";

export default function Cta() {
  const site = useSiteData();
  const block = sectionBlocks(site.content, "cta")[0];
  const image = mediaUrl(block?.imageUrl) || ctaImage;
  const title = block?.title || "See Our Impact in Action";
  const body = block?.body || "Discover how RENERG is transforming Rwanda's energy landscape through innovative solar solutions, sustainable development, and community empowerment.";

  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-teal-900 to-emerald-900">
        <div className="absolute top-1/4 left-10 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
        <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:64px_64px]"></div>
      </div>

      <div className="container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-white">
            <h2 className="renerg-section text-white mb-6">
              {title.includes("Impact") ? (
                <>See Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-emerald-300">Impact</span> in Action</>
              ) : title}
            </h2>

            <div className="renerg-body text-slate-200 mb-8 max-w-2xl">
              <HtmlContent html={body} imageTo="/#blog" />
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              <Link to="/about" className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10">
                <div className="renerg-stat text-teal-300 mb-1">15+</div>
                <div className="renerg-small text-slate-300">Years experience →</div>
              </Link>
              <Link to="/projects" className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10">
                <div className="renerg-stat text-emerald-300 mb-1">1.3GW+</div>
                <div className="renerg-small text-slate-300">Solar projects →</div>
              </Link>
              <Link to="/projects" className="text-center p-4 bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 hover:bg-white/10">
                <div className="renerg-stat text-teal-300 mb-1">12+</div>
                <div className="renerg-small text-slate-300">Countries →</div>
              </Link>
            </div>

            <Link
              to="/projects"
              className="group inline-flex items-center justify-center h-14 px-8 font-semibold rounded-xl bg-gradient-to-r from-teal-500 to-emerald-600 text-white shadow-2xl shadow-teal-500/25 hover:scale-105 transition-all duration-300"
            >
              See our projects
              <i className="mdi mdi-arrow-right align-middle ms-2 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            </Link>
          </div>

          <div className="relative">
            <PhotoLink
              to="/projects"
              src={image}
              alt="RENERG projects"
              className="w-full h-auto transform group-hover:scale-110 transition-transform duration-700"
              wrapClassName="relative group rounded-3xl shadow-2xl shadow-black/30"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/40 via-transparent to-emerald-900/30"></div>
              <div className="absolute bottom-8 left-8 text-white font-semibold text-lg backdrop-blur-sm bg-black/30 px-4 py-2 rounded-xl">
                View our projects →
              </div>
            </PhotoLink>
            <div className="absolute -z-10 -inset-8">
              <div className="w-full h-full border-2 border-teal-500/20 rounded-3xl rotate-3"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
